import React from 'react';
import PropTypes from 'prop-types';
import MCExample from '@learningblocks/exp-constants/lib/Images/microcentrifuge_topview_example.svg';
import { Image } from '@learningblocks/storybook-components';
import { LidOpen } from './LidOpen';
import { LidClosed } from './LidClosed';
import { LidActionButtons } from './LidActionButtons';
import { BalancedPrompt } from './BalancedPrompt';
import { Wrapper } from '../../Wrapper';
import { InstructionBlock } from './InstructionBlock';
import { Heading } from './Heading';
import { InstructionContent } from './InstructionContent';
import { MCStateContext } from '../..';

import './style.scss';

/**
 * TopViewContent: Renders the content to be displayed in top view of
 * centrifuge modal window
 */
export function TopViewContent(props) {
  const { isLidOpen } = React.useContext(MCStateContext);

  const renderEquipment = () =>
    isLidOpen ? (
      <LidOpen
        toggleLid={props.toggleLid}
        onDrop={props.onDrop}
        slots={props.slots}
        balanced={props.balanced}
      />
    ) : (
      <LidClosed toggleLid={props.toggleLid} />
    );

  return (
    <Wrapper className='mc_topview'  >
      <Wrapper className='' tabindex="0" style={{ display: 'inherit' }}>
        <InstructionBlock className='mc_topview_instruction' tabindex="0" aria-label="Instruction Block here">
          <Heading className='mc_topview_instruction_header' />
          <InstructionContent className='mc_topview_instruction_text' />
          <Image
            className='mc_topview_instruction_image'
            src={MCExample}
            alt='examples of balanced rotors'
          />
        </InstructionBlock>
      </Wrapper>
      <Wrapper className='mc_topview_balancingblock' tabindex="0" aria-label={!isLidOpen ? 'The microcentrifuge is now closed, click on the open lid button to open the microcentrifuge.' : 'The microcentrifuge has 12 slots labeled slot 1 to 12, like the points on a clock, tracked clockwise.'}>
        <LidActionButtons onClick={props.toggleLid} balanced={props.balanced} />
        {renderEquipment()}
        <BalancedPrompt className='mc_topview_balancingblock_prompt' />
      </Wrapper>
    </Wrapper>
  );
}

TopViewContent.propTypes = {
  /**
   * callback function to trigger onclick lid- toggles open and close state of lid
   */
  toggleLid: PropTypes.func,
  /**
   * callback function to trigger on drop at top view of centrifuge
   */
  onDrop: PropTypes.func,
  /**
   * data of all slots
   * slot position start from 1 to 12 ; 1 being at' 12 0 clock' position and so on
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id of slot
       */
      id: PropTypes.number,
      /**
       * specifies if rotor is present
       */
      rotor: PropTypes.bool,
      /**
       * specifes if solution is present
       */
      tube: PropTypes.bool,
    })
  ),
};
